export default "__VITE_ASSET__ItGT7Js7__"